document.addEventListener('DOMContentLoaded', function() {
  var search = window.location.search;
  if (!search) return;

  document.querySelectorAll('main a[href*="atomicdisc.com"]').forEach(function(link) {
    // Avoid doubling up parameters if already present
    if (link.href.indexOf('?') === -1) {
      link.href = link.href + search;
    } else {
      link.href = link.href + '&' + search.substring(1);
    }
  });
});